'use client';
import { useState } from 'react';

export default function CalculatorCompoundInterest() {
  const [principal, setPrincipal] = useState(10000);
  const [rate, setRate] = useState(5);
  const [time, setTime] = useState(10);
  const [frequency, setFrequency] = useState(12);

  const amount = principal * Math.pow(1 + (rate / 100) / frequency, frequency * time);
  const interest = amount - principal;

  return (
    <div className="bg-white rounded-3xl p-8 shadow-modern-xl">
      <h2 className="text-2xl font-bold mb-6">Investment Details</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold mb-2">Principal Amount</label>
          <input type="number" value={principal} onChange={(e) => setPrincipal(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Annual Interest Rate (%)</label>
          <input type="number" step="0.1" value={rate} onChange={(e) => setRate(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Time Period (years)</label>
          <input type="number" value={time} onChange={(e) => setTime(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Compounding Frequency</label>
          <select value={frequency} onChange={(e) => setFrequency(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg">
            <option value={1}>Annually</option>
            <option value={4}>Quarterly</option>
            <option value={12}>Monthly</option>
            <option value={365}>Daily</option>
          </select>
        </div>
      </div>
      <div className="mt-8 space-y-4">
        <div className="p-6 bg-purple-50 rounded-xl">
          <h3 className="text-lg font-bold mb-2">Future Value</h3>
          <p className="text-3xl font-bold text-purple-600">${amount?.toFixed(2)}</p>
        </div>
        <div className="p-4 bg-slate-50 rounded-lg">
          <p className="text-sm text-slate-600">Total Interest Earned</p>
          <p className="text-xl font-bold text-slate-900">${interest?.toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
}
